<template>
  <div :class="[
      'flex items-center py-5',
      {
        'gap-4': props.label
      }
  ]">
    <div class="border-b border-[#373737] w-full"></div>
    <div v-if="props.label">{{ props.label }}</div>
    <div class="border-b border-[#373737] w-full"></div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  label?: string
}

const props = defineProps<Props>()
</script>
